/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';

import exportWithBoundary from '../../../helpers/exportWithBoundary';
import { HorizontalFlow, VerticalFlow } from '../../_layouts';
import Icon from '../Icon';
import Text from '../Text';
import {
  AlertBody,
  AlertContainer,
  AlertContent,
  AlertFlow,
  AlertIcon,
} from './styles';

function Alert(props) {
  const { variant, title, subtitle, bodyText, children, className } = props;
  let icon = variant;
  if (icon === 'danger') icon = 'attention-solid';

  return (
    <AlertContainer color={variant} className={className}>
      <AlertFlow>
        <AlertIcon>
          <Icon type={icon} size={24} />
        </AlertIcon>
        <AlertContent spacing='1rem'>
          {(title || subtitle) && (
            <VerticalFlow spacing='0.25rem'>
              {title && (
                <Text size={200} strong>
                  {title}
                </Text>
              )}
              {subtitle && (
                <Text size={100} color='neutral-800'>
                  {subtitle}
                </Text>
              )}
            </VerticalFlow>
          )}
          {bodyText && (
            <AlertBody dangerouslySetInnerHTML={{ __html: bodyText }} />
          )}
          {children && <HorizontalFlow>{children}</HorizontalFlow>}
        </AlertContent>
      </AlertFlow>
    </AlertContainer>
  );
}

Alert.defaultProps = {
  className: '',
  variant: 'informational',
  title: null,
  subtitle: null,
  bodyText: null,
  children: null,
};

Alert.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  bodyText: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

function AlertFallback() {
  return <AlertContainer />;
}

export default exportWithBoundary(Alert, AlertFallback);
